import React from 'react';
import { ServerInterface } from "src/store/mine_craft/serversSlice";

import { RightSidebar } from "../../../_partials/Layout";
import ServerMeta from "./_ServerMeta";

// Pure identity & metadata — the operational controls (start/stop/restart,
// console, live stats) moved into the Content tab's control bar, where they
// get real button sizes and sit next to the state they act on.
const _SidebarShow = ({ server }: { server: ServerInterface | undefined }) => {
  return (
    <RightSidebar>
      <ServerMeta server={server} />
    </RightSidebar>
  )
}

export default _SidebarShow;
